import { render, staticRenderFns } from "./Afiliates.vue?vue&type=template&id=1ebe2c4b"
import script from "./Afiliates.vue?vue&type=script&lang=js"
export * from "./Afiliates.vue?vue&type=script&lang=js"
import style0 from "./Afiliates.vue?vue&type=style&index=0&id=1ebe2c4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports